import {Component} from "@angular/core";
import {faBell} from '@fortawesome/free-regular-svg-icons';
import {SidebarRightService} from "@webmate-web-core/shared/components/sidebarright/sidebarright.service";
import {UserNotificationAreaComponent} from "@webmate-web-core/shared/components/sidebarright/usernotificationarea.component";
import {UserNotificationService} from "@webmate-web-core/shared/services/usernotification.service";
import {map, mergeMap} from "rxjs/operators";
import moment from "moment";
import {ChannelInfo, UserNotification} from "@webmate-web-core/shared/types/notification";

@Component({
    selector: 'wm-usernotifications',
    templateUrl: './usernotifications.component.html',
    styleUrls: ['./usernotifications.component.less'],
})
export class UserNotificationsComponent {

    faBell = faBell;
    newNotificationsAvailable = false;

    constructor(private sidebarRightService: SidebarRightService, private userNotificationService: UserNotificationService) {}

    ngOnInit() {
        this.userNotificationService.observeNotificationCenterNotifications$().pipe(mergeMap(notifications => {
            return this.userNotificationService.getChannelInfo$('notification-center').pipe(map(channelInfo => [notifications, channelInfo] as [Array<UserNotification>, ChannelInfo]))
        })).subscribe(([notifications, channelInfo]: [Array<UserNotification>, ChannelInfo]) => {
            const seenDate = channelInfo.lastSeen;
            const lastDate = notifications[0]?.creationTime;
            this.newNotificationsAvailable = (!seenDate && !!lastDate) || (!!lastDate && moment(lastDate).isAfter(seenDate));
            if (this.newNotificationsAvailable) {
                this.openUserNotifications();
            }
        });
    }

    openUserNotifications() {
        this.sidebarRightService.openSidebar(UserNotificationAreaComponent, { sidebarName: 'Notifications' })
    }
}
